var map = {
	"./slide-18-1.jpg": "d914",
	"./slide-18-2.jpg": "1157",
	"./slide-18-3.jpg": "00e4",
	"./slide-18-4.jpg": "6961",
	"./slide-18-5.jpg": "6c17"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "114d";